import axios, { AxiosRequestConfig } from "axios";
import { addSagAuthInterceptor } from "@sazka/utils/http-clients/sag-auth-interceptor";
import { addBtmIdInterceptor } from "@sazka/utils/http-clients/btm-id-interceptor";
import { useSagOptions } from "@sazka/utils/http-clients/use-sag-options";

const { getSagApiUrl } = useSagOptions();

/**
 * Axios basic configuration
 * Some general configuration can be added like timeout, headers, params etc. More details can be found on https://github.com/axios/axios
 * */
const config: AxiosRequestConfig = {
    baseURL: getSagApiUrl("realtime360"),
};

export const biRealtimeHttpClient = axios.create(config);

/** Adding the request interceptors */
addSagAuthInterceptor(biRealtimeHttpClient);
addBtmIdInterceptor(biRealtimeHttpClient);
